import { Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      className="border-t border-white/10 mt-32 py-16 px-6 lg:px-12 bg-[#0A0A0C]"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif-display text-2xl text-[#F2EBE5] mb-3">
            Sinjar Remembered
          </div>
          <p className="text-sm text-[#A19D98] leading-relaxed">
            A digital memorial and educational experience honoring the victims
            and survivors of the 2014 Yazidi genocide in Sinjar, Iraq. Not for
            entertainment — for remembrance and learning.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Sources & Recognition</div>
          <ul className="text-sm text-[#A19D98] space-y-2">
            <li>United Nations Investigative Team (UNITAD)</li>
            <li>UN Recognition of Genocide — 2016</li>
            <li>Yazda — Survivor-led NGO</li>
            <li>Nadia&apos;s Initiative</li>
            <li>Public testimonies of survivors</li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">In Remembrance</div>
          <p className="font-serif-display text-lg text-[#D4AF37] italic leading-snug">
            “The truth is the only justice we have left.”
          </p>
          <p className="text-xs text-[#6E6B67] mt-3">— Yazidi survivor testimony</p>
        </div>
      </div>

      {/* Owner & Contact */}
      <div
        className="max-w-6xl mx-auto mt-16 pt-12 border-t border-white/10"
        data-testid="footer-owner-contact"
      >
        <div className="overline text-[#D4AF37] mb-3">Created and maintained by</div>
        <div
          className="font-serif-display text-3xl lg:text-4xl text-[#F2EBE5]"
          data-testid="footer-owner-name"
        >
          Ghazy Halou
        </div>
        <p className="text-sm text-[#A19D98] mt-4 max-w-2xl leading-relaxed">
          For questions, collaboration, corrections to the historical record, or
          to share a survivor testimony for consideration — please reach out.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-8">
          <a
            href="mailto:haloughazy1997@gmail.com"
            data-testid="footer-contact-email"
            className="inline-flex items-center gap-3 border border-white/15 px-5 py-3 text-sm text-[#F2EBE5] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-500"
          >
            <Mail className="w-4 h-4" strokeWidth={1.5} />
            haloughazy1997@gmail.com
          </a>
          <a
            href="tel:+61470689403"
            data-testid="footer-contact-phone"
            className="inline-flex items-center gap-3 border border-white/15 px-5 py-3 text-sm text-[#F2EBE5] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-500"
          >
            <Phone className="w-4 h-4" strokeWidth={1.5} />
            +61 470 689 403
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-white/5 text-xs text-[#6E6B67] flex flex-wrap justify-between gap-4">
        <span>Educational memorial. Built with respect.</span>
        <span>© Ghazy Halou — In memory of the lost. In hope for the missing.</span>
      </div>
    </footer>
  );
};

export default Footer;
